import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import { publicApi } from '../api/client';
import { Loader2, Calendar as CalIcon, User } from 'lucide-react';

const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    publicApi.getBlogPost(slug).then((d) => { setPost(d); setLoading(false); }).catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-32 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div>;
  if (!post) return <div className="py-32 text-center text-slate-500">Post not found. <Link to="/blog" className="text-[#304b71] underline">Back to blog</Link></div>;

  const date = new Date(post.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <>
      <PageBanner title={post.title} subtitle={post.excerpt} image={post.image} crumbs={[{ label: 'Travel Guide', to: '/blog' }, { label: post.title }]} />
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500 mb-8 pb-8 border-b border-slate-100">
            <span className="inline-flex items-center gap-2"><User size={14} /> {post.author}</span>
            <span className="inline-flex items-center gap-2"><CalIcon size={14} /> {date}</span>
            {post.tags?.length > 0 && <div className="flex flex-wrap gap-2">{post.tags.map((t) => <span key={t} className="bg-[#f6f8fa] px-3 py-1 rounded-full text-xs text-[#304b71]">{t}</span>)}</div>}
          </div>
          <article className="prose prose-slate max-w-none">
            <div className="text-slate-700 leading-[1.85] text-lg whitespace-pre-line">{post.content}</div>
          </article>
        </div>
      </section>
    </>
  );
};

export default BlogDetail;
